/* Partner-only display: activate solely from an explicit Shopify Collabs
 * referral identifier. A generic analytics UTM must never unlock prices. */
(() => {
  const KEY = 'bkCreatorPartnerVerifiedV62';
  const params = new URLSearchParams(window.location.search);
  const referralKeys = ['dt_id', 'affiliate_link_id'];
  const explicitReferral = referralKeys.some(key => {
    const value = params.get(key);
    return typeof value === 'string' && value.trim().length > 0;
  });
  // Use tab-only persistence to preserve prices across a legitimate referral
  // journey, but do not trust stale state from earlier theme versions.
  if (explicitReferral) {
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }
  let active = explicitReferral;
  if (!active) {
    try { active = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
  }
  document.documentElement.classList.toggle('bk-partner-active', active);
})();
